module.exports = __webpack_public_path__ + "static/analytics-desktop-c42d5f275d9b2181c2e191105aed41b0.png";